import { render, staticRenderFns } from "./cloudwatch.vue?vue&type=template&id=28b804ba&"
import script from "./cloudwatch.vue?vue&type=script&lang=js&"
export * from "./cloudwatch.vue?vue&type=script&lang=js&"
import style0 from "./cloudwatch.vue?vue&type=style&index=0&id=28b804ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports